/// <amd-module name="Artifacts/Nuget/NuGetPackageDetails" />
/* tslint:disable:no-require-imports */
import * as Contracts from "Artifacts/Nuget/Contracts/NuGet";
import * as VSS_Common_Contracts from "VSS/Platform/Contracts/WebApi";

import JsonPatchOperation = VSS_Common_Contracts.JsonPatchOperation;
export class PackageVersionDetails implements Contracts.PackageVersionDetails {
  public readonly listed: boolean;
  public readonly views: JsonPatchOperation;
  constructor(listed?: boolean, viewToAdd?: string) {
    this.listed = listed || false;
    const patchDocument: VSS_Common_Contracts.JsonPatchOperation = {
      from: "",
      op: VSS_Common_Contracts.Operation.Add,
      path: "/views/-",
      value: viewToAdd,
    };
    this.views = patchDocument;
  }
}
